@if (filtersAap) {
  <div class="filtres-data-list">
    <div class="filtres-content">
      @if (filtersDossierValues && cacheInitEnd) {
        <app-filters-dossier
          [displayAnnees]="false"
          [displayReunion]="false"
          [displayInstance]="false"
          [filtersDossierValues]="filtersDossierValues"
        (onChange)="onFiltersDossierChange($event)"></app-filters-dossier>
      }
    </div>
  </div>
}

<div class="container-fluid">
  @if (cacheInitEnd) {
    <div class="table-header">
      <h1 class="mat-table-header-prefix">
        {{ title }}
        <span
        class="counter">{{ total }} {{ ((total > 1) ? 'general.resultats' : 'general.resultat') | translate }}</span>
      </h1>
      <div class="mat-table-header-suffix-filtre filtre-recherche">
        @if (filterSearchValue && cacheInitEnd) {
          <app-filter-search [floatLabel]="'always'"
            (onChange)="onFilterSearchChange($event)"
            [filterSearchValue]="filterSearchValue"
          ></app-filter-search>
        }
      </div>

      <div class="mat-table-header-suffix-filtre filtre-statut">
        <app-filter-by-api
          [matSelectId]="'filters-rs-statut'"
          [config]="filterStatut"
          (changeSelection)="onFilterStatutChange($event)"
          (onInit)="onFilterStatutChange($event)"
          [floatLabel]="'always'"
          >
        </app-filter-by-api>
      </div>

      <div class="mat-table-header-suffix-filtre filtre-statut">
        <app-filter-by-api
          [matSelectId]="'filters-rs-statut-dossier'"
          [config]="filterStatutDossier"
          (changeSelection)="onFilterStatutDossierChange($event)"
          (onInit)="onFilterStatutDossierChange($event)"
          [floatLabel]="'always'"
          >
        </app-filter-by-api>
      </div>

      <div class="mat-table-header-suffix-filtre datepicker-header-filter">
        <mat-form-field>
          <mat-label>Date de remise</mat-label>
          <mat-date-range-input [formGroup]="rangeDateRemise" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Entre">
            <input matEndDate formControlName="end" placeholder="Et">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="mat-table-header-suffix-filtre ">
        <app-filter-by-api
          [matSelectId]="'filters-rs-retard'"
          [config]="filterRetard"
          (changeSelection)="onFilterRetardChange($event)"
          (onInit)="onFilterRetardChange($event)"
          [floatLabel]="'always'"
          >
        </app-filter-by-api>
      </div>
      <div class="clearfix"></div>
    </div>
  }

  <div class="container-mat-table container-mat-table-sticky" [autoSize]="autoSize">
    <table class="mat-table-data-list mat-table-dense" mat-table matSort [dataSource]="liste"
      (matSortChange)="changeSort($event)">


      <ng-container matColumnDef="candidat.nom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dossier</th>
        <td mat-cell *matCellDef="let element">
          <a href="mailto:{{ element.dossier.candidat.email }}">
            {{ (element.dossier.candidat.nom | uppercase) + ' ' + element.dossier.candidat.prenom }}<br>
          </a>
          <a [routerLink]="'/dossiers/voir-dossier'+'/'+element.dossier.id +'/viewMode'" target="_blank"
            title="{{ element.dossier.numeroDossier }}">
            {{ element.dossier.numeroDossier }}
          </a>
          @if (element.dossier.statut === StatutDossier.Desiste) {

            <span class="badge statut-3 ml-2">
              {{ ('general.dossier.statut.' + element.dossier.statut) | translate }}
              {{ element.dossier.dateDesistement | date : dateShort }}
            </span>

          }
        </td>
      </ng-container>


      <ng-container matColumnDef="aide.label">
        <th mat-header-cell *matHeaderCellDef>{{ 'general.aides' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          @if (authService.hasRoleAdmin()) {
            <span class="nom-aap"
              >
              <a [routerLink]="'/aides-commissions/aides/edit/'+element.dossier.aide.id"
                target="_blank">
                {{ element.dossier.aide.label }}
              </a>
            </span>
          } @else {
            {{ element.dossier.aide.label }}
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="rapportScientifiqueConfiguration.libelle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Configuration
        </th>
        <td mat-cell *matCellDef="let element">
          <a [routerLink]="'/aides-commissions/aides/edit/'+element.dossier.aide.id+'/0/rapports-scientifiques/'+element.rapportScientifiqueConfiguration.id">
            {{ element.rapportScientifiqueConfiguration.libelle }}
          </a><br>
          @if (element.final) {
            <span>Rapport final</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="rapportScientifique">
        <th mat-header-cell *matHeaderCellDef>
          Rapport scientifique
        </th>
        <td mat-cell *matCellDef="let element">
          @if (element.rapportScientifique) {
            <div>
              <a [routerLink]="'/dossiers/voir-rapport-scientifique/' + element.rapportScientifique.id + '/viewMode'"
                target="_blank">
                {{ element.rapportScientifique.numero }}
              </a>
            </div>
          }
        </td>
      </ng-container>


      <ng-container matColumnDef="dateDebutFinancement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Début projet</th>
        <td mat-cell *matCellDef="let element">
          {{ element.dossier.dateDebutFinancement | date: 'dd/MM/y' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dateFinFinancement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin projet</th>
        <td mat-cell *matCellDef="let element">
          {{ element.dossier.dateFinFinancement | date: 'dd/MM/y' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="statut">
        <th mat-header-cell *matHeaderCellDef>Statut</th>
        <td mat-cell *matCellDef="let element">
          @if (!element.exclu) {
            {{ ('general.rapportScientifique.statut.' + element.statut) |translate }}
          }
          @if (element.exclu) {
            <span class="badge badge-danger">
              exclu
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="dureeReelle">
        <th mat-header-cell *matHeaderCellDef>Durée projet</th>
        <td mat-cell *matCellDef="let element">
          {{ element.dossier.dureeReelle }} mois
        </td>
      </ng-container>

      <ng-container matColumnDef="dateOuverture">
        <th mat-header-cell *matHeaderCellDef>Date ouverture</th>
        <td mat-cell *matCellDef="let element">
          <span class="date-modif"
            [class.date-locked]="element.rapportScientifiqueConfigurationDossier?.dateOuverture"
            >
            @if (element.rapportScientifiqueConfigurationDossier?.dateOuverture) {
              <em class="fa fa-lock"
              ></em>
            }
            {{ element.dateOuverture | date: 'dd/MM/y' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="dateRemise">
        <th mat-header-cell *matHeaderCellDef>Date de remise</th>
        <td mat-cell *matCellDef="let element">
          <span class="date-modif"
            [class.date-locked]="element.rapportScientifiqueConfigurationDossier?.dateRemise"
            >
            @if (element.rapportScientifiqueConfigurationDossier?.dateRemise) {
              <em class="fa fa-lock"
              ></em>
            }
            {{ element.dateRemise | date: 'dd/MM/y' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="avancement">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          @if (element.nbJoursRemise !== null) {
            @if (element.nbJoursRemise < 0 && element.nbJoursRemise >= -nbJoursRelance) {
              <span
                class="badge badge-warning">
                remise dans {{ -1 * element.nbJoursRemise }} jours
              </span>
            }
            @if (element.nbJoursRemise === 0) {
              <span class="badge badge-warning">
                remise aujourd'hui
              </span>
            }
            @if (element.nbJoursRemise > 0) {
              <span class="badge badge-danger">
                retard de  {{ element.nbJoursRemise }} jours
              </span>
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let element">

          @if (authService.isAdmin()) {
            <button mat-icon-button (click)="openComments(element)"
              class="btn-action"
              [class.noTask]="!element.hasOpenTask"
              >
              <mat-icon>comment</mat-icon>
            </button>
          }

          @if (authService.isAdmin()) {
            <a mat-icon-button [matMenuTriggerFor]="menuActions" class="btn-action"
              >
              <mat-icon>more_horiz</mat-icon>
            </a>
          }

          <mat-menu #menuActions="matMenu" [overlapTrigger]="true">
            <button
              (click)="editDates(element)"
              [disabled]="element.statut === statutsEnum.traite"
              mat-menu-item
              >
              Modification dates ouverture/remise
            </button>

            @if (allowExclusionAction && !element.exclu) {
              <button
                (click)="exclureDossier(element)"
                [disabled]="element.statut === statutsEnum.traite"
                mat-menu-item
                >
                Exclure le dossier
              </button>
            }

            @if (allowExclusionAction && element.exclu) {
              <button
                (click)="reintegrerDossier(element)"
                [disabled]="element.statut === statutsEnum.traite"
                mat-menu-item
                >
                Réintégrer le dossier
              </button>
            }

            @if (element.rapportScientifique) {
              <button
                [disabled]="element.statut === statutsEnum.aSaisir || element.statut === statutsEnum.aVenir || element.statut === statutsEnum.enCours"
                mat-menu-item
                (click)="rouvrir(element)"
                >
                Rouvrir le rapport
              </button>
            }

            @if (element.rapportScientifique) {
              <button
                [disabled]="element.statut === statutsEnum.expertise"
                mat-menu-item
                (click)="passerEnExpertise(element)"
                >
                Passer en expertise
              </button>
            }

            @if (element.rapportScientifique) {
              <button
                mat-menu-item
                [disabled]="element.statut === statutsEnum.traite"
                (click)="marquerCommeTraite(element)"
                >
                Marquer comme traité
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" [class.deleting]="row['editing']"></tr>

    </table>
    <mat-paginator class="mat-paginator-sticky" [pageSize]="30" [length]="total"
      [pageSizeOptions]="pageSizeOptions" (page)="onPaginatorPageChange()"
    showFirstLastButtons="true"></mat-paginator>
  </div>
</div>
